import Seo from "@/components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo title="Privacy Policy — Fitness Calculator" description="Our privacy policy. Fitness Calculator runs entirely in your browser and does not collect your inputs." path="/privacy" />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-16 space-y-6">
        <h1 className="text-4xl font-bold tracking-tight">Privacy Policy</h1>
        <p className="text-muted-foreground leading-relaxed">
          Fitness Calculator is designed to respect your privacy. All calculators run locally in your browser — we do not receive, log or store the values you enter into any calculator on this website.
        </p>
        <h2 className="text-2xl font-bold pt-4">Analytics</h2>
        <p className="text-muted-foreground leading-relaxed">
          We may use privacy-friendly analytics (for example, Google Analytics with IP anonymization) to understand which calculators are most useful. This aggregated data does not identify individuals.
        </p>
        <h2 className="text-2xl font-bold pt-4">Cookies</h2>
        <p className="text-muted-foreground leading-relaxed">
          We use minimal cookies or local storage — for example, to remember your preferred colour theme (light / dark).
        </p>
        <h2 className="text-2xl font-bold pt-4">Third parties</h2>
        <p className="text-muted-foreground leading-relaxed">
          We do not sell or share personal information with third parties.
        </p>
        <h2 className="text-2xl font-bold pt-4">Contact</h2>
        <p className="text-muted-foreground leading-relaxed">
          Questions about privacy? Reach us via the <a className="underline hover:text-foreground" href="/contact">contact page</a>.
        </p>
      </div>
    </>
  );
}
